var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-view",
    [
      _c(
        "cms-heading",
        { attrs: { title: "Overzicht loggers", icon: "magicon-tiles" } },
        [
          _c(
            "cms-button",
            {
              attrs: {
                color: "positive",
                icon: "magicon-plus",
                route: "logger-add",
              },
            },
            [_vm._v("Toevoegen")]
          ),
          _vm.userIsAdmin
            ? _c(
                "cms-upload-button",
                {
                  attrs: {
                    icon: "magicon-download",
                    start: true,
                    allowed: "csv",
                    accept: ".csv",
                    url: _vm.uploadCsvUrl,
                  },
                  on: {
                    complete: _vm.onUploadCsvComplete,
                    error: _vm.onUploadCsvError,
                  },
                },
                [_vm._v("Importeer .csv")]
              )
            : _vm._e(),
          _vm.userIsAdminOrAdvisor
            ? _c("cms-dropdown", {
                staticClass: "button-dropdown",
                attrs: {
                  placeholder: "Exporteren...",
                  options: _vm.exportOptions,
                },
                on: { input: _vm.onExport },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "cms-heading",
        { attrs: { title: "Filter resultaten", level: "2" } },
        [
          _c(
            "cms-button",
            {
              attrs: { disabled: !_vm.hasFilter },
              on: { click: _vm.resetFilters },
            },
            [_vm._v("Reset filters")]
          ),
        ],
        1
      ),
      _c("complex-filter-panel", {
        attrs: { options: _vm.filterOptions },
        on: { add: _vm.onFilterAdded, remove: _vm.onFilterRemoved },
        model: {
          value: _vm.filter,
          callback: function ($$v) {
            _vm.filter = $$v
          },
          expression: "filter",
        },
      }),
      _c(
        "cms-heading",
        { attrs: { title: _vm.resultsTitle, level: "2" } },
        [
          _c(
            "cms-button",
            {
              attrs: {
                color: "highlight-1",
                icon: "magicon-ok-circle",
                disabled: _vm.selectedLoggers.length === 0,
              },
              on: { click: _vm.makeSelection },
            },
            [
              _vm._v(
                "Selectie maken (" + _vm._s(_vm.selectedLoggers.length) + ")"
              ),
            ]
          ),
          _c(
            "cms-button",
            {
              attrs: {
                color: "default-dark",
                icon: "magicon-close",
                disabled: _vm.selectedLoggers.length === 0,
              },
              on: { click: _vm.resetSelection },
            },
            [_vm._v("Reset selectie")]
          ),
          _c("cms-searchbar", {
            model: {
              value: _vm.searchQuery,
              callback: function ($$v) {
                _vm.searchQuery = $$v
              },
              expression: "searchQuery",
            },
          }),
        ],
        1
      ),
      _c(
        "cms-table-panel",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            "item-count": _vm.loggers.totalCount || 0,
            "items-per-page": _vm.itemsPerPage,
            offset: _vm.offset,
            placeholder: !_vm.loggers.items || !_vm.loggers.items.length,
            "show-count": "true",
            clickable: "true",
          },
          on: {
            page: function ($event) {
              _vm.offset = arguments[0]
            },
          },
        },
        [
          _c(
            "cms-table-header",
            [
              _c(
                "cms-th",
                {
                  attrs: { field: "serialNumber" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Serienummer")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "typeId" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Type")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "state" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Status")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "owner" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Eigendom")]
              ),
              _vm.showAllocationData
                ? _c(
                    "cms-th",
                    {
                      attrs: { field: "allocationProjectCode" },
                      model: {
                        value: _vm.sort,
                        callback: function ($$v) {
                          _vm.sort = $$v
                        },
                        expression: "sort",
                      },
                    },
                    [_vm._v("Projectcode")]
                  )
                : _vm._e(),
              _c(
                "cms-th",
                {
                  attrs: { field: "mutationStartDate" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Startdatum")]
              ),
              _vm.showAllocationData
                ? _c(
                    "cms-th",
                    {
                      attrs: { field: "allocationEndDate" },
                      model: {
                        value: _vm.sort,
                        callback: function ($$v) {
                          _vm.sort = $$v
                        },
                        expression: "sort",
                      },
                    },
                    [_vm._v("Verwachte einddatum")]
                  )
                : _vm._e(),
              _vm.userIsAdminOrAdvisor
                ? _c(
                    "cms-th",
                    {
                      attrs: { field: "allocationActionDeadline" },
                      model: {
                        value: _vm.sort,
                        callback: function ($$v) {
                          _vm.sort = $$v
                        },
                        expression: "sort",
                      },
                    },
                    [_vm._v("Afh. termijn actie")]
                  )
                : _vm._e(),
              _vm.showRepairData
                ? _c(
                    "cms-th",
                    {
                      attrs: { field: "repairReference" },
                      model: {
                        value: _vm.sort,
                        callback: function ($$v) {
                          _vm.sort = $$v
                        },
                        expression: "sort",
                      },
                    },
                    [_vm._v("Reparatie-batch")]
                  )
                : _vm._e(),
              _vm.userIsAdminOrAdvisor
                ? _c(
                    "cms-th",
                    {
                      attrs: { field: "documentReference" },
                      model: {
                        value: _vm.sort,
                        callback: function ($$v) {
                          _vm.sort = $$v
                        },
                        expression: "sort",
                      },
                    },
                    [_vm._v("Document ref.")]
                  )
                : _vm._e(),
              _vm.userIsAdminOrAdvisor
                ? _c(
                    "cms-th",
                    {
                      attrs: { field: "purchaseDate" },
                      model: {
                        value: _vm.sort,
                        callback: function ($$v) {
                          _vm.sort = $$v
                        },
                        expression: "sort",
                      },
                    },
                    [_vm._v("Datum aanschaf")]
                  )
                : _vm._e(),
              _vm.userIsAdminOrAdvisor
                ? _c(
                    "cms-th",
                    {
                      attrs: { field: "purchaseValue" },
                      model: {
                        value: _vm.sort,
                        callback: function ($$v) {
                          _vm.sort = $$v
                        },
                        expression: "sort",
                      },
                    },
                    [_vm._v("Aanschafwaarde")]
                  )
                : _vm._e(),
              _c(
                "cms-th",
                {
                  attrs: { field: "comments" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Opmerkingen")]
              ),
              _c(
                "cms-th",
                { staticStyle: { width: "40px" } },
                [
                  _c("cms-checkbox", {
                    attrs: { checked: _vm.allLoggersChecked },
                    on: { input: _vm.toggleSelection },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.loggers.items, function (logger) {
            return _c(
              "tr",
              {
                class: { selected: _vm.isSelected(logger) },
                on: {
                  click: function ($event) {
                    return _vm.showLogger(logger)
                  },
                },
              },
              [
                _c("td", [_vm._v(_vm._s(logger.serialNumber))]),
                _c("td", [_vm._v(_vm._s(logger.type.title))]),
                _c(
                  "td",
                  [
                    _c("cms-text-label", {
                      attrs: {
                        title: _vm._f("loggerState")(logger.state),
                        color: _vm._f("loggerStateColor")(logger.state),
                      },
                    }),
                  ],
                  1
                ),
                _c("td", [_vm._v(_vm._s(logger.owner))]),
                _vm.showAllocationData
                  ? _c("td", [
                      _vm._v(
                        _vm._s(
                          logger.activeAllocation
                            ? logger.activeAllocation.project.code
                            : ""
                        )
                      ),
                    ])
                  : _vm._e(),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm._f("date")(
                        logger.latestMutation &&
                          logger.latestMutation.data.startDate
                          ? logger.latestMutation.data.startDate
                          : "",
                        "LL"
                      )
                    )
                  ),
                ]),
                _vm.showAllocationData
                  ? _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm._f("date")(
                            logger.activeAllocation
                              ? logger.activeAllocation.endDate
                              : "",
                            "LL"
                          )
                        )
                      ),
                    ])
                  : _vm._e(),
                _vm.userIsAdminOrAdvisor
                  ? _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm._f("actionDeadline")(
                            logger.activeAllocation
                              ? logger.activeAllocation.actionDeadline
                              : null,
                            logger.activeAllocation
                              ? logger.activeAllocation.project.actionDeadline
                              : null
                          )
                        )
                      ),
                    ])
                  : _vm._e(),
                _vm.showRepairData
                  ? _c("td", [
                      _vm._v(
                        _vm._s(
                          logger.activeRepair
                            ? logger.activeRepair.reference
                            : ""
                        )
                      ),
                    ])
                  : _vm._e(),
                _vm.userIsAdminOrAdvisor
                  ? _c("td", [_vm._v(_vm._s(logger.documentReference))])
                  : _vm._e(),
                _vm.userIsAdminOrAdvisor
                  ? _c("td", [
                      _vm._v(_vm._s(_vm._f("date")(logger.purchaseDate, "LL"))),
                    ])
                  : _vm._e(),
                _vm.userIsAdminOrAdvisor
                  ? _c("td", [
                      _vm._v(_vm._s(_vm._f("currency")(logger.purchaseValue))),
                    ])
                  : _vm._e(),
                _c("td", [_vm._v(_vm._s(logger.comments))]),
                _c(
                  "td",
                  {
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("cms-checkbox", {
                      attrs: { checked: _vm.isSelected(logger) },
                      on: {
                        input: function ($event) {
                          return _vm.updateSelection(logger, arguments[0])
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }